// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.106.2/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.106.2/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* overridden by src/lib/themes/guiHelpers.js */

.extension-chooser_modal-content_bkZcx.extension-chooser_full-screen_tEAo5 {
  overflow-y: hidden !important;
}

.extension-chooser_container_sEr7c {
  display: flex;
  flex-direction: column;
  padding: 2rem;
  height: calc(100vh - 3.125rem - var(--stage-fullscreen-top, 0px));
}

.extension-chooser_header_XSBIQ {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-shrink: 0;
}

.extension-chooser_title_azhbd {
  margin: 0;
  font-size: 2rem;
  font-weight: bold;
}

.extension-chooser_openLibraryButton_vxvhP,
.extension-chooser_openCustomExtension_NW7D1,
.extension-chooser_openCodeButton_bUd6b {
  justify-content: center;
  background-color: var(--looks-secondary);
  border: none;
  border-radius: 2000px;
  width: 50px;
  height: 50px;
  cursor: pointer;
  transition: filter 0.2s ease-in-out;
  position: absolute;
  bottom: 30px;
  overflow: hidden;
  display: flex;
  align-items: center;
  z-index: 1000;
}

.extension-chooser_openCustomExtension_NW7D1 {
  bottom: 100px;
  font-size: 16px;
}

.extension-chooser_openCodeButton_bUd6b {
  bottom: 170px;
  font-size: 16px;
}

.extension-chooser_openLibraryButton_vxvhP:hover,
.extension-chooser_openCustomExtension_NW7D1:hover,
.extension-chooser_openCodeButton_bUd6b:hover {
  filter: brightness(1.2);
}

.extension-chooser_content_Qqa_n {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  overflow-y: auto;
  width: 100%;
}

.extension-chooser_ExtTitle_sc4DN {
  font-size: x-large;
  font-weight: bold;
  margin-left: 10px;
  color: white;
}

.extension-chooser_ExtId_mJljF {
  margin-left: 10px;
  color: white;
}

.extension-chooser_Extbg_K4vgg {
  margin: 10px auto;
  width: 90%;
  min-height: 105px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  padding: 10px;
  overflow: hidden;
}

.extension-chooser_manages_JG8sS {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  min-height: 0;
}

.extension-chooser_button_KI4aA {
  font-family: inherit;
  font-size: 14px;
  background-color: white;
  border: none;
  padding: 0.5rem 1rem;
  margin: 0 5px;
  border-radius: 4px;
  cursor: pointer;
  font-family: inherit;
  font-weight: bold;
}

.extension-chooser_button_KI4aA:active,
.extension-chooser_button_KI4aA:focus-within {
  box-shadow: 0 0 0 3px var(--looks-transparent);
}

.extension-chooser_button_KI4aA:disabled {
  opacity: 0.6;
  cursor: default;
}

.extension-chooser_failedInfo_o6eib {
  display: flex;
  align-items: center;
  margin: 4px 0 0 10px;
}

.extension-chooser_failedBadge_OgFeh {
  display: inline-block;
  padding: 2px 8px;
  border-radius: 999px;
  background-color: rgba(0, 0, 0, 0.45);
  color: white;
  font-size: 12px;
  font-weight: bold;
  white-space: nowrap;
}

.extension-chooser_failedHint_pjFM0 {
  margin-left: 8px;
  color: rgba(255, 255, 255, 0.9);
  font-size: 12px;
  text-shadow: 0 0 3px rgba(0, 0, 0, 0.8);
}

.extension-chooser_openLibraryButtonIcon_YzNT_ {
  width: 16px;
  height: 16px;
}

.extension-chooser_extensionTypeIcon_KbI9J {
  width: auto;
  height: 20px;
  padding-left: 5px;
  filter: invert(1) drop-shadow(rgba(0, 0, 0, 0.8) 0px 0px 3px);
}

.extension-chooser_dropHint_ZD5zX {
  margin: 10px auto 0;
  color: white;
  font-size: 14px;
  opacity: 0.75;
  text-align: center;
}

.extension-chooser_dropOverlay_LhJFr {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(0, 0, 0, 0.55);
  border: 4px dashed rgba(255, 255, 255, 0.85);
}

.extension-chooser_dropOverlayInner_K84yc {
  color: white;
  font-size: 24px;
  font-weight: bold;
  text-align: center;
  pointer-events: none;
}`, "",{"version":3,"sources":["webpack://./src/components/extension-chooser/extension-chooser.css"],"names":[],"mappings":"AAAA,+CAA+C;;AAE/C;EACE,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,iEAAiE;AACnE;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,iBAAiB;AACnB;;AAEA;;;EAGE,uBAAuB;EACvB,wCAAwC;EACxC,YAAY;EACZ,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,mCAAmC;EACnC,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;;;EAGE,uBAAuB;AACzB;;AAEA;EACE,OAAO;EACP,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,UAAU;EACV,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,WAAW;EACX,aAAa;AACf;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,uBAAuB;EACvB,YAAY;EACZ,oBAAoB;EACpB,aAAa;EACb,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;;EAEE,8CAA8C;AAChD;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,oBAAoB;EACpB,qCAAqC;EACrC,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,+BAA+B;EAC/B,eAAe;EACf,uCAAuC;AACzC;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,6DAA6D;AAC/D;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,qCAAqC;EACrC,4CAA4C;AAC9C;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,oBAAoB;AACtB","sourcesContent":["/* overridden by src/lib/themes/guiHelpers.js */\n\n.modal-content.full-screen {\n  overflow-y: hidden !important;\n}\n\n.container {\n  display: flex;\n  flex-direction: column;\n  padding: 2rem;\n  height: calc(100vh - 3.125rem - var(--stage-fullscreen-top, 0px));\n}\n\n.header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  flex-shrink: 0;\n}\n\n.title {\n  margin: 0;\n  font-size: 2rem;\n  font-weight: bold;\n}\n\n.openLibraryButton,\n.openCustomExtension,\n.openCodeButton {\n  justify-content: center;\n  background-color: var(--looks-secondary);\n  border: none;\n  border-radius: 2000px;\n  width: 50px;\n  height: 50px;\n  cursor: pointer;\n  transition: filter 0.2s ease-in-out;\n  position: absolute;\n  bottom: 30px;\n  overflow: hidden;\n  display: flex;\n  align-items: center;\n  z-index: 1000;\n}\n\n.openCustomExtension {\n  bottom: 100px;\n  font-size: 16px;\n}\n\n.openCodeButton {\n  bottom: 170px;\n  font-size: 16px;\n}\n\n.openLibraryButton:hover,\n.openCustomExtension:hover,\n.openCodeButton:hover {\n  filter: brightness(1.2);\n}\n\n.content {\n  flex: 1;\n  min-height: 0;\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  align-items: center;\n  overflow-y: auto;\n  width: 100%;\n}\n\n.ExtTitle {\n  font-size: x-large;\n  font-weight: bold;\n  margin-left: 10px;\n  color: white;\n}\n\n.ExtId {\n  margin-left: 10px;\n  color: white;\n}\n\n.Extbg {\n  margin: 10px auto;\n  width: 90%;\n  min-height: 105px;\n  border-radius: 10px;\n  display: flex;\n  align-items: center;\n  padding: 10px;\n  overflow: hidden;\n}\n\n.manages {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  width: 100%;\n  min-height: 0;\n}\n\n.button {\n  font-family: inherit;\n  font-size: 14px;\n  background-color: white;\n  border: none;\n  padding: 0.5rem 1rem;\n  margin: 0 5px;\n  border-radius: 4px;\n  cursor: pointer;\n  font-family: inherit;\n  font-weight: bold;\n}\n\n.button:active,\n.button:focus-within {\n  box-shadow: 0 0 0 3px var(--looks-transparent);\n}\n\n.button:disabled {\n  opacity: 0.6;\n  cursor: default;\n}\n\n.failedInfo {\n  display: flex;\n  align-items: center;\n  margin: 4px 0 0 10px;\n}\n\n.failedBadge {\n  display: inline-block;\n  padding: 2px 8px;\n  border-radius: 999px;\n  background-color: rgba(0, 0, 0, 0.45);\n  color: white;\n  font-size: 12px;\n  font-weight: bold;\n  white-space: nowrap;\n}\n\n.failedHint {\n  margin-left: 8px;\n  color: rgba(255, 255, 255, 0.9);\n  font-size: 12px;\n  text-shadow: 0 0 3px rgba(0, 0, 0, 0.8);\n}\n\n.openLibraryButtonIcon {\n  width: 16px;\n  height: 16px;\n}\n\n.extensionTypeIcon {\n  width: auto;\n  height: 20px;\n  padding-left: 5px;\n  filter: invert(1) drop-shadow(rgba(0, 0, 0, 0.8) 0px 0px 3px);\n}\n\n.dropHint {\n  margin: 10px auto 0;\n  color: white;\n  font-size: 14px;\n  opacity: 0.75;\n  text-align: center;\n}\n\n.dropOverlay {\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 9999;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-color: rgba(0, 0, 0, 0.55);\n  border: 4px dashed rgba(255, 255, 255, 0.85);\n}\n\n.dropOverlayInner {\n  color: white;\n  font-size: 24px;\n  font-weight: bold;\n  text-align: center;\n  pointer-events: none;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modal-content": `extension-chooser_modal-content_bkZcx`,
	"modalContent": `extension-chooser_modal-content_bkZcx`,
	"full-screen": `extension-chooser_full-screen_tEAo5`,
	"fullScreen": `extension-chooser_full-screen_tEAo5`,
	"container": `extension-chooser_container_sEr7c`,
	"header": `extension-chooser_header_XSBIQ`,
	"title": `extension-chooser_title_azhbd`,
	"openLibraryButton": `extension-chooser_openLibraryButton_vxvhP`,
	"openCustomExtension": `extension-chooser_openCustomExtension_NW7D1`,
	"openCodeButton": `extension-chooser_openCodeButton_bUd6b`,
	"content": `extension-chooser_content_Qqa_n`,
	"ExtTitle": `extension-chooser_ExtTitle_sc4DN`,
	"extTitle": `extension-chooser_ExtTitle_sc4DN`,
	"ExtId": `extension-chooser_ExtId_mJljF`,
	"extId": `extension-chooser_ExtId_mJljF`,
	"Extbg": `extension-chooser_Extbg_K4vgg`,
	"extbg": `extension-chooser_Extbg_K4vgg`,
	"manages": `extension-chooser_manages_JG8sS`,
	"button": `extension-chooser_button_KI4aA`,
	"failedInfo": `extension-chooser_failedInfo_o6eib`,
	"failedBadge": `extension-chooser_failedBadge_OgFeh`,
	"failedHint": `extension-chooser_failedHint_pjFM0`,
	"openLibraryButtonIcon": `extension-chooser_openLibraryButtonIcon_YzNT_`,
	"extensionTypeIcon": `extension-chooser_extensionTypeIcon_KbI9J`,
	"dropHint": `extension-chooser_dropHint_ZD5zX`,
	"dropOverlay": `extension-chooser_dropOverlay_LhJFr`,
	"dropOverlayInner": `extension-chooser_dropOverlayInner_K84yc`
};
export default ___CSS_LOADER_EXPORT___;
